import { render } from "./configView.vue?vue&type=template&id=9b63f9ec&scoped=true"
import script from "./configView.vue?vue&type=script&lang=js"
export * from "./configView.vue?vue&type=script&lang=js"

import "./configView.vue?vue&type=style&index=0&id=9b63f9ec&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b63f9ec"]])

export default __exports__